// extracted by mini-css-extract-plugin
module.exports = {"main":"DefaultTemplate_main__wplH_","content":"DefaultTemplate_content__OZCMy","search-fade-in":"DefaultTemplate_search-fade-in__B6_7T"};